import { toast } from "react-toastify";
import { apiUrl } from "../../Constants/Constants";

export const createBatchRenewModalLogic = (
  { fetchWithToken, getInfo, onLogout, closeFinalModal },
  modalContext
) => {
  const {
    openUpModal,
    description,
    confirmTitle,
    payloadConfirm,
    toDo,
    closeModal,
  } = modalContext;

  const paybatchRenewPay = (selectedAccounts, amount) => {
    openUpModal();
    confirmTitle("تایید پرداخت");
    let texter = (
      <>
        آیا مطمئن هستید که می‌خواهید مبلغ
        <strong style={{ padding: "5px", display: "inline-block" }}>
          {amount.toLocaleString("fa-IR")} تومان
        </strong>
        را از کیف پول خود پرداخت کنید ؟
      </>
    );
    description(texter);
    toDo(() => payWithWalletOnRen);
    payloadConfirm(selectedAccounts);
  };

  const payWithWalletOnRen = (accounts) => {
    const former = new FormData();
    former.append("selectedAccounts", accounts);

    fetchWithToken(
      apiUrl + "user/pay-renew-wallet",
      {
        method: "POST",
      },
      former
    ).then((data) => {
      if (data.status === "200") {
        // window.location.replace(data.data);

        toast.success("با موفقیت پرداخت گردید.");

        closeModal("batchRenew");
        closeModal("confirm");
        getInfo();
      }

      if (data.status === "401") {
        onLogout();
      }
    });
  };

  const fetchPaymentUrl = (selectedAccounts) => {
    const former = new FormData();
    former.append("selectedAccounts", selectedAccounts);

    fetchWithToken(
      apiUrl + "user/create-payment",
      {
        method: "POST",
      },
      former
    ).then((data) => {
      if (data.status === "200") {
        toast.info("در حال انتقال به دروازه پرداخت...");
        window.location.replace(data.data);
      }

      if (data.status === "401") {
        onLogout();
      }
    });
  };

  return {
    fetchPaymentUrl,
    paybatchRenewPay,
  };
};
